import React from 'react';
import { Row, Col, Button } from 'antd';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import BasicLayout from 'layout/Basic';

const Title = styled.h1`
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.41;
    letter-spacing: normal;
    text-align: center;
    color: ${(props) => props.color || props.theme.colors.greyishBrown};
`;

interface Props {
    message: string;
}

const ForbiddenPage = ({ message }: Props): React.JSX.Element => {
    const router = useRouter();
    return (
        <BasicLayout ads={{ skyscraper: [], billboard: [], wideboardTop: [] }}>
            <Row>
                <Col span={24}>
                    <Title>{message} </Title>
                </Col>

                <Col span={24}>
                    <Row justify="center">
                        <Col>
                            <Button type="primary" onClick={() => router.back()}>
                                Wróć do poprzedniej strony
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </BasicLayout>
    );
};

export default ForbiddenPage;
